const isPermissionsMap = (x: unknown): x is Record<string, string[]> => {
  return (
    typeof x === 'object' &&
    x !== null &&
    Object.values(x).every(
      (v) => Array.isArray(v) && v.every((i) => typeof i === 'string'),
    )
  );
};

const isPermissionsList = (x: unknown): x is string[] => {
  return Array.isArray(x) && x.every((i) => typeof i === 'string');
};

export const safeParsePermissionsMap = (
  json: string,
): Record<string, string[]> | undefined => {
  try {
    const parsed = JSON.parse(json);
    return isPermissionsMap(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
};

export const safeParsePermissionsList = (
  json: string,
): string[] | undefined => {
  try {
    const parsed = JSON.parse(json);
    return isPermissionsList(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
};
